import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  ControlLabel,
  Alert,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

import isEmpty from "lodash.isempty";
import { getReport } from "../../../redux/actions/reportAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util"

const history = createHashHistory();

const propTypes = {
  getReport: PropTypes.func.isRequired
};
let isLoading = "false", csvData = [];
class AffiliateCommissions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'AFFILIATE_COMMISSION',
      path: ["Home", "Affiliate Commission Report"],
      links: ["home", "report/affiliate/commissions"],
      date: new Date(),
      range: false,
      disabled: false,
      isLoading: "false",
      csvData: "",
      reportData: "",
      startDate: new Date(),
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = date => { this.setState({ startDate: date })};
  onChangeStartDateRange = date => this.setState({ startDateRange: date });
  
  changeDatePicker = status => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    let formData;

    if (!err) {
      if (this.state.range == true) {
        let dateRange = this.state.startDateRange;
        formData = {
          startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
          endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
          site_id: localStorage.getItem("siteID")
        };
      } else {
        formData = {
          startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
          site_id: localStorage.getItem("siteID")
        };
      }

      this.props.getReport(formData, 'report/affiliate-commission');
    }
  }

  Clear = () => {};

  handlePageChange = page => {};

  componentWillMount() {
    isLoading = "true";
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getReport({startDate: moment(this.state.startDate).format('YYYY-MM-DD'), site_id: localStorage.getItem("siteID")}, 'report/affiliate-commission');
  }
  componentWillReceiveProps(nextProps) {

    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.props.history.push("/restrictedAccess");
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
      }
    }

    if (this.props.reportData !== nextProps.reportData) {
      if (nextProps.reportData) {
        isLoading = "false";
        this.setState({ reportData: nextProps.reportData.data });
        this.handleExport(nextProps.reportData);
      }
    }

    

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }


  }

  handleExport = data => {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
    dateRange = this.state.startDateRange;
    }
    let setDate = (this.state.range == true && this.state.startDateRange) ? moment(dateRange[0]).format('MM/DD/YYYY') +' - '+moment(dateRange[1]).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY');
    csvData = [
      [
        'Data up to the date: ' + setDate,
      ],
      [
        'Name',
        'Legal Name',
        'Sales',
        'Subscribers',
        'Refunds',
        'Commission', 
      ]
    ];

    if(data && data.data){
      data.data.map((data, index) => {
        csvData.push([
          data.name,
          data.legal_name,
          data.sales,
          data.subscribers,
          data.refund,
          data.commision,
        ]);
      })
    }

    this.setState({ csvData: csvData });
  };

  // shouldComponentUpdate(nextProps, nextState) {
  //   if (this.state.reportData === nextState.reportData && nextState.activecities === this.state.citiesList) {
  //     return false
  //   }
  //   return true
  // }
  
  render() {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
    dateRange = this.state.startDateRange;
    }

    let { reportData } = this.state;
    
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Affiliate Commission Report</header>
            <div className="panel-body">
              <Row className="reportfilter">
                <Col md={3} xs={12}>
                  <ControlLabel>Date</ControlLabel>
                  <FormGroup controlId="formOfferTitle">
                    {this.state.range == false ? (
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                      />
                    ) : (
                      <DateRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                      />
                    )}
                  </FormGroup>
                </Col>                
                <Col md={5} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  {this.state.csvData ? (
                    <CSVLink
                      data={this.state.csvData}
                      filename={"employee-commission-report.csv"}
                      className="btn btn-default"
                    >
                      Export CSV
                    </CSVLink>
                  ) : null}
                  {this.state.range == false ? (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Range
                    </a>
                  ) : (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Date
                    </a>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th colSpan="10">Data up to the date: {(this.state.range == true && this.state.startDateRange) ? moment(dateRange[0]).format('MM/DD/YYYY') +' - '+moment(dateRange[1]).format('MM/DD/YYYY') : (this.state.startDate) ? moment(this.state.startDate).format('MM/DD/YYYY') : moment(new Date()).format('MM/DD/YYYY')}</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Legal Name</th>
                  <th>Sales</th>
                  <th>Subscribers</th>
                  <th>Refunds</th>
                  <th>Commission</th> 
                </tr>
              </thead>
              <tbody>
              	{(reportData && reportData.length > 0) ?
                  reportData.map((data, index) =>
                    <tr key={index}>
                      <td>{data.name}</td>
                      <td>{data.legal_name}</td>
                      <td>{data.sales}</td>
                      <td>{data.subscribers}</td>
                      <td>{data.refund}</td>
                      <td>{data.commision}</td>
                    </tr>
                  )
                  :
                  <tr>
                    <td colSpan="6" style={{textAlign : 'center'}}>Data Not Available</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    reportData: state.reportReducer.reportData,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getReport,
  })
)(AffiliateCommissions);


// WEBPACK FOOTER //
// ./src/app/views/admin/reports/AffiliateCommissions.js